<highcharts-chart
  class="m-basic-column-chart"
  [Highcharts]="Highcharts"
  [options]="chartOptions"></highcharts-chart>
